import { render, staticRenderFns } from "./Cols-25-25-25-25.vue?vue&type=template&id=6df8a6ad&scoped=true&"
import script from "./Cols-25-25-25-25.vue?vue&type=script&lang=js&"
export * from "./Cols-25-25-25-25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df8a6ad",
  null
  
)

export default component.exports